import React, { useEffect, useState } from "react";

import useWindowSize from "../hooks/useWindowSize";
import { Promotion } from "../types";
import FullscreenModal from "./FullscreenModal";
import InclusionDetail from "./InclusionDetail";
import PromotionBanner from "./PromotionBanner";
import StyleThumbnails from "./StyleThumbnails";

/**
 * THIS COMPONENT IS EXPECTED TO BE USED IN EITHER THE PromotionsScreen or SpecialpromotionsScreen COMPONENTS
 * @param props
 * @constructor
 */

const PromotionSelector = (props: {
  promotions: Promotion[];
  selectedPromotion: Promotion | null;
  onClickPromotion: (promotion: Promotion) => void;
}) => {
  const windowSize = useWindowSize();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalClosing, setIsModalClosing] = useState(false);
  const [modalPromo, setModalPromo] = useState<Promotion | null>(null);

  const [lastSelectedPromo, setLastSelectedPromo] = useState(
    props.promotions[0]
  );

  useEffect(() => {
    if (props.selectedPromotion) {
      setLastSelectedPromo(props.selectedPromotion);
    } else {
      // If there are 'preselected' promotions, select that one by default
      const preselectPromos = props.promotions.filter(
        (item) => item.preselected
      );
      if (preselectPromos.length > 0) {
        onClickPromo(preselectPromos[0]);
      }
    }
  }, []);

  const onClickPromo = (promo: Promotion) => {
    setLastSelectedPromo(promo);
    props.onClickPromotion(promo);
  };

  const onClickMoreDetails = (promotion: Promotion) => {
    setModalPromo(promotion);
    setIsModalVisible(true);
  };

  const onModalClose = () => {
    setIsModalVisible(false);
    setIsModalClosing(false);
  };

  const onClickModalSelectPromo = () => {
    if (
      modalPromo &&
      (!props.selectedPromotion || props.selectedPromotion.id !== modalPromo.id)
    ) {
      props.onClickPromotion(modalPromo);
    }
    setIsModalClosing(true);
  };

  return (
    <>
      <div className={"style-content container"}>
        {windowSize.width < 768 ? (
          props.promotions.map((item) => {
            return (
              <PromotionBanner
                key={item.id}
                promotion={item}
                selected={!!props.selectedPromotion}
                onClick={onClickPromo}
                onClickMoreDetails={onClickMoreDetails}
                showPopout={true}
              />
            );
          })
        ) : (
          <>
            <PromotionBanner
              promotion={lastSelectedPromo}
              selected={!!props.selectedPromotion}
              onClick={onClickPromo}
              onClickMoreDetails={onClickMoreDetails}
              showPopout={true}
            />
            <StyleThumbnails
              imageStyle={"tall"}
              activeStyle={"selectable"}
              items={props.promotions}
              selectedId={
                props.selectedPromotion ? props.selectedPromotion.id : -1
              }
              onClickItem={(index) => onClickPromo(props.promotions[index])}
            />
          </>
        )}
        {isModalVisible && modalPromo !== null && (
          <FullscreenModal
            title={modalPromo.title}
            closing={isModalClosing}
            onClose={onModalClose}
          >
            <InclusionDetail
              inclusion={modalPromo}
              onClickBack={() => setIsModalClosing(true)}
              onClickNext={onClickModalSelectPromo}
              nextBtnTitle={"Select This Promotion"}
            />
          </FullscreenModal>
        )}
      </div>
    </>
  );
};

export default PromotionSelector;
